import * as React from 'react';

import {LoadingPage} from '../loading-page/loading-page';
import {PopoverInfo} from '../popover-info/popover-info';
import {SavedSettingToast} from '../saved-setting-toast/saved-setting-toast';

import {Card} from './card';

import styles from './card-content-with-header.module.css';

type Props = {
    title: string;
    subtitle: string | React.ReactNode;
    isLoading?: boolean;
    content: React.ReactNode;
    banner?: React.ReactNode;
    /** Renders next to the title using the same pattern as FormField / Label tooltips. */
    tooltipInfo?: React.ReactNode;
    shouldTooltipFadeIn?: boolean;
    hasBorder?: boolean;
    fitContent?: boolean;
    saveToastState?: 'saving' | 'complete' | 'initial';
};

export function CardContentWithHeader(props: Props) {
    const {
        title,
        subtitle,
        isLoading,
        content,
        banner,
        tooltipInfo,
        shouldTooltipFadeIn,
        hasBorder = true,
        fitContent = true,
        saveToastState = 'initial',
    } = props;

    return (
        <Card hasBorder={hasBorder} fitContent={fitContent}>
            <div className='pad-16'>
                <div className={styles.header}>
                    <SavedSettingToast state={saveToastState}>
                        {tooltipInfo ? (
                            <div className={styles['title-row']}>
                                <div className={styles.title}>{title}</div>
                                <PopoverInfo
                                    size={18}
                                    info={tooltipInfo}
                                    shouldFadeIn={shouldTooltipFadeIn}
                                />
                            </div>
                        ) : (
                            <div className={styles.title}>{title}</div>
                        )}
                    </SavedSettingToast>
                    {banner}
                    <div className={styles.subtitle}>{subtitle}</div>
                </div>
                {isLoading ? <LoadingPage padding={0} /> : content}
            </div>
        </Card>
    );
}
